import request from '@/utils/request'

/**
 * 获取试卷列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getPapers(data) {
  return request({
    url: 'api/getPapers',
    method: 'post',
    params: data
  })
}

/**
 * 删除试卷
 * @param data
 * @returns {AxiosPromise}
 */
export function deletePaper(data) {
  return request({
    url: 'api/deletePaper',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加试卷
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditPaper(data) {
  return request({
    url: 'api/addOrEditPaper',
    method: 'post',
    params: data
  })
}

/**
 * 获取试卷试题列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getProblemListById(data) {
  return request({
    url: 'api/getProblemListById',
    method: 'post',
    params: data
  })
}

/**
 * 获取问卷列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchListGxj(data) {
  return request({
    url: 'api/getResearchListGxj',
    method: 'post',
    params: data
  })
}

/**
 * 获取问卷问题列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getTopicListById(data) {
  return request({
    url: 'api/getTopicListById',
    method: 'post',
    params: data
  })
}

/**
 * 删除问卷
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteResearch(data) {
  return request({
    url: 'api/deleteResearch',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加问卷
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditResearch(data) {
  return request({
    url: 'api/addOrEditResearch',
    method: 'post',
    params: data
  })
}

/**
 * 获取试卷列表(经销商端)
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerPapers(data) {
  return request({
    url: 'api/getDealerPapers',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加试卷(经销商端)
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDealerPaper(data) {
  return request({
    url: 'api/addOrEditDealerPaper',
    method: 'post',
    params: data
  })
}

/**
 * 获取问卷列表(经销商端)
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerResearchList(data) {
  return request({
    url: 'api/getDealerResearchList',
    method: 'post',
    params: data
  })
}

/**
 * 修改或添加问卷(经销商端)
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditDealerResearch(data) {
  return request({
    url: 'api/addOrEditDealerResearch',
    method: 'post',
    params: data
  })
}
